module.exports = __webpack_public_path__ + "static/digital_technology_services-8703818639252b42b9ee0804cd2e5b77.jpg";